export default __webpack_public_path__ + "static/img_0291-54c56b0f55dc91539958d766d6a2d414.png";